import { atom } from 'recoil';

export const useConciergeState = atom<boolean>({
  key: 'useConcierge',
  default: false,
});
